import { RouteConfig } from 'vue-router';
import { isMobile } from '@/common/ts/common';
const PAGE_TITLE = '重庆市大学生创意传播作品大赛';
const baseUrl = 'cqcc';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () =>
    isMobile() ? import('./ViewHolder.vue') : import('./ViewHolderPc.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () =>
        isMobile() ? import('./pages/Home.vue') : import('./pages-pc/home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () =>
        isMobile() ? import('./pages/Rule.vue') : import('./pages-pc/rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () =>
        isMobile() ? import('./pages/News.vue') : import('./pages-pc/news.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },

    {
      path: 'signup',
      name: `${baseUrl}-signup`,
      component: () => import('./pages-pc/signup.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'signup/photo',
      name: `${baseUrl}-signup-photo`,
      component: () => import('./pages-pc/photo-signup.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'signup/video',
      name: `${baseUrl}-signup-video`,
      component: () => import('./pages-pc/video-signup.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'signup/audio',
      name: `${baseUrl}-signup-audio`,
      component: () => import('./pages-pc/audio-signup.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'signup/report',
      name: `${baseUrl}-signup-report`,
      component: () => import('./pages-pc/report-signup.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'signup/ai',
      name: `${baseUrl}-signup-ai`,
      component: () => import('./pages-pc/ai-signup.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'works',
      name: `${baseUrl}-works`,
      component: () => import('./pages-pc/works.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages-pc/detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'login',
      name: `${baseUrl}-login`,
      component: () => import('./pages-pc/login.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'userDetails',
      name: `${baseUrl}-userDetails`,
      component: () => import('./pages/UserDetails.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
